import { render, staticRenderFns } from "./VistaPreviaComponent.vue?vue&type=template&id=4936c942&scoped=true"
import script from "./VistaPreviaComponent.vue?vue&type=script&lang=js"
export * from "./VistaPreviaComponent.vue?vue&type=script&lang=js"
import style0 from "./VistaPreviaComponent.vue?vue&type=style&index=0&id=4936c942&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4936c942",
  null
  
)

export default component.exports